import React, { useEffect, useState, useMemo } from "react";
import Classes from "./Routes.module.css";
import RoutesSlider from "./RoutesSlider";
import ReschedulePopup from "../Appointments/AppointmentDetails/ReschedulePopup/ReschedulePopup";
import { AnimatePresence } from "framer-motion";
import UpdateStatusPopup from "../../../../GlobalComponents/UpdateStatusPopup/UpdateStatusPopup";
import { useSelector } from "react-redux";
import backend from "../../../../../api";

export default function Routes() {
  const [routes, setRoutes] = useState({ date: "", employees: [] });
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);

  const company = useSelector((s) => s?.companyInfo?.info);
  const companyId = company?._id;

  // load board
  useEffect(() => {
    let alive = true;
    (async () => {
      if (!companyId) return;
      setLoading(true);
      try {
        const { data } = await backend.get("/api/bookings/board", {
          params: { companyId }, // optional: add date param
        });
        console.log("board fetch:", data);
        if (!alive) return;
        if (data?.ok) setRoutes({ date: data.date, employees: data.employees });
      } catch (e) {
        console.error("board fetch error:", e);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [companyId]);

  const normalized = query.trim().toLowerCase();
  const filteredEmployees = useMemo(() => {
    return (routes.employees || []).map((col) => {
      if (!normalized) return col;
      const filtered = (col.appointments || []).filter((a) => {
        const hay = `${a.name} ${a.phone} ${a.address} ${a.requestedFuel} ${a.fuelType} ${a.service}`.toLowerCase();
        return hay.includes(normalized);
      });
      return { ...col, appointments: filtered };
    });
  }, [routes.employees, normalized]);

  // ───────────────── move/assign booking ─────────────────
  const handleMove = async (bookingId, fromColId, toColId) => {
    try {
      const payload = { employeeId: toColId === "unassigned" ? null : toColId };
      const { data } = await backend.post(`/api/bookings/${bookingId}/assign`, payload);
      if (!data?.ok) return;

      // local UI update (no refetch)
      setRoutes((prev) => {
        const moved = prev.employees.flatMap((c) => c.appointments).find((a) => a.id === bookingId);
        if (!moved) return prev;

        const nextEmployees = prev.employees.map((c) => {
          // remove from all columns
          return { ...c, appointments: c.appointments.filter((a) => a.id !== bookingId) };
        });

        const target = nextEmployees.find((c) => c.id === toColId) ||
          nextEmployees.find((c) => c.id === "unassigned");
        if (target) target.appointments = [moved, ...target.appointments];

        return { ...prev, employees: nextEmployees };
      });
    } catch (e) {
      console.error("assign error:", e);
      // (optional) toast error
    }
  };

  // popups
  const [openReschedulePopup, setopenReschedulePopup] = useState(false);
  const handleCloseUReschedulePopup = () => setopenReschedulePopup(false);
  const handleopenReschedulePopup = (booking) => {
    setSelectedBooking(booking || null);
    setopenReschedulePopup(true);
  };

  const [openUpdateStatusPopup, setopenUpdateStatusPopup] = useState(false);
  const handleCloseUpdateStatusPopup = () => setopenUpdateStatusPopup(false);
  const handleOpenUpdateStatusPopup = (booking) => {
    setSelectedBooking(booking || null);
    setopenUpdateStatusPopup(true);
  };

  return (
    <>
      <div className={Classes.hero}>
        <div className={Classes.header}>
          <div>
            <h3 className={Classes.title3} >Routes</h3>
            <h5 className={Classes.text} >Track and manage all of your routes.</h5>
          </div>

          <div className={Classes.headerRight}>
            <div className={Classes.searcCon}>
              <img src="/assets/images/search.png" alt="icon" />
              <input
                type="text"
                placeholder="Search name, phone, address…"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className={Classes.hero2}>
          <RoutesSlider
            loading={loading}
            employees={filteredEmployees}
            // for inline status label change in card (cosmetic)
            setEmployees={(next) => setRoutes((r) => ({ ...r, employees: next }))}
            // pass dynamic actions
            handleopenReschedulePopup={handleopenReschedulePopup}
            handleOpenUpdateStatusPopup={handleOpenUpdateStatusPopup}
            onMove={handleMove}
            allEmployees={routes.employees} // for "Move to >" menu
          />
        </div>
      </div>

      <AnimatePresence>
        {openReschedulePopup && (
          <ReschedulePopup
            closePopup={handleCloseUReschedulePopup}
            submitPopup={handleCloseUReschedulePopup}
            booking={selectedBooking}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {openUpdateStatusPopup && (
          <UpdateStatusPopup
            closePopup={handleCloseUpdateStatusPopup}
            booking={selectedBooking}
            initialStatus={selectedBooking?.status || "Upcoming"}
            onSaved={(uiStatus) => {
              // reflect status change in UI locally
              setRoutes((prev) => ({
                ...prev,
                employees: prev.employees.map((col) => ({
                  ...col,
                  appointments: col.appointments.map((a) =>
                    a.id === selectedBooking?.id ? { ...a, status: uiStatus } : a
                  ),
                })),
              }));
              handleCloseUpdateStatusPopup();
            }}
          />
        )}
      </AnimatePresence>
    </>
  );
}
